<template>
  <vue-final-modal
    classes="flex justify-center items-center"
    content-class="relative flex flex-col h-auto mx-4 p-4 border dark:border-gray-800 bg-white rounded-lg shadow-lg modal-overflow"
  >
    <div class="lg:px-8 lg:py-6 max-w-7xl mx-auto px-4 py-4 sm-py-6 sm:px-6">
      <div class="max-w-3xl mx-auto">
        <div class="mb-6">
          <label class="text-lg mb-2 text-gray-600">Upload Image</label>
          <file-picker
            v-model="form.file"
            key="fileupload"
            class="w-full md:w-1/2"
            type="file"
            accept="image/*"
            :errors="errors.file"
            @update:modelValue="errors = {}"
          />
          <loading-button
            class="mt-2 w-full md:w-auto"
            primary
            v-if="form.file"
            :loading="uploading"
            @click="handleFileUpload"
          >
            Upload
          </loading-button>
        </div>
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <action-button @click="closeModal" icon>
            <svg viewBox="0 0 20 20" fill="currentColor" class="x w-4 h-4">
              <path fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd">
              </path>
            </svg>
          </action-button>
        </div>

        <div v-if="images">
          <label class="text-lg mb-2 text-gray-600">Select Image</label>
          <div class="mt-2 grid grid-cols-3 lg:grid-cols-5 gap-2">
            <div v-if="newFile" @click="select(newFile)" class="h-32 cursor-pointer" :key="newFile.id">
              <img class="object-cover h-full w-full" :src="newFile.image">
            </div>
            <div @click="select(file)" class="h-32 cursor-pointer" v-for="file in images.data" :key="file.id">
              <img class="object-cover h-full w-full" :src="file.image">
            </div>
          </div>

          <div class="flex justify-between mt-6">
            <action-button @click="fetchImages(images.prev_page_url)" rel="prev" :disabled="! images.prev_page_url">
              Previous
            </action-button>

            <div>
              Page {{ images.current_page }} of {{ images.last_page }}
            </div>

            <action-button @click="fetchImages(images.next_page_url)" rel="next" :disabled="! images.next_page_url">
              Next
            </action-button>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import axios from 'axios'
import FilePicker from '@/Components/Inputs/FilePicker.vue'
import LoadingButton from '@/Components/Buttons/Loading.vue'
import ActionButton from '@/Components/Buttons/Action.vue'

export default {
  name: 'imageUploadModal',

  components: {
    FilePicker,
    LoadingButton,
    ActionButton,
  },

  props: {
    callback: null
  },

  mounted() {
    this.fetchImages()
  },

  data() {
    return {
      form: {
        file: null
      },
      loading: false,
      uploading: false,
      images: null,
      newFile: null,
      errors: {},
    }
  },

  methods: {
    handleFileUpload() {
      this.uploading = true

      let formData = new FormData()
      formData.append('file', this.form.file)

      axios.post(route('hq.contents.images.store'), formData)
        .then(res => this.select(res.data.file))
        .catch(err => this.errors = err.response.data.errors)
        .finally(() => this.uploading = false)
    },

    fetchImages(url = null) {
      if (!url) {
        url = route('hq.contents.images.index', { page: 1 })
      }

      this.newFile = null
      this.loading = true
      axios.get(url)
        .then(({ data }) => this.images = data.images)
        .finally(() => this.loading = false)
    },

    select(file) {
      let data = { id: file.id, src: file.image }

      this.callback(data)
      this.closeModal()
    },

    closeModal() {
      this.$vfm.hideAll()
    }
  }
}
</script>
